// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"LoadingSpinner_loadingSpinner__bb8xF","spinner":"LoadingSpinner_spinner__iKlWN","spinnerContainer":"LoadingSpinner_spinnerContainer__hdIt8"};